export const reduxKey: string = 'flags';
export const actionKey = '@@flags';
